import { Box, LinearProgress } from '@mui/material';

// Relative Imports
import './LoadingPage.css';

const LoadingPage = (props) => {
    return (
        <div id="LoadingPage" className='page'>
            <div className='container'>
                <Box className="preloaderContainer" sx={{ width: '100%' }}>
                    <LinearProgress color='inherit'/>
                </Box>
                <p className="preloaderText">Verifying your session...</p>

            </div>
        </div>
    );
};

export default LoadingPage;
